import React from 'react';

export default () => (
    <td className="appointment_empty__item">
        <p>Запись недоступна</p>
    </td>
)



// WEBPACK FOOTER //
// frontend/src/modules/appointment-table/row/empty-item/index.jsx